import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { GetKpisAction, SortKpisAction } from "./kpi.actions";
import { Kpis } from "src/app/shared/models/kpis.model";
import { KpiService } from "../services/kpi.service";
import { tap } from "rxjs";

@State<Kpis>({
  name: "KpiStore",
  defaults: {
    users: 0,
    ctf: [],
  },
})
@Injectable()
export class KpiState {
  constructor(private service: KpiService) {}

  @Selector()
  static selectUsers(state: Kpis) {
    return state.users;
  }

  @Selector()
  static selectCtf(state: Kpis) {
    return state.ctf;
  }

  @Action(GetKpisAction)
  getKpisAction(ctx: StateContext<Kpis>, action: GetKpisAction) {
    return this.service.getKpis(action.siteId).pipe(
      tap((res) => {
        const state = ctx.getState();
        ctx.setState({
          ...state,
          users: res.users,
          ctf: res.ctf,
        });
      })
    );
  }

  @Action(SortKpisAction)
  sortKpisAction(ctx: StateContext<Kpis>, action: SortKpisAction) {
    const state = ctx.getState();
    const columnToOrder = action.columnToOrder;
    const isOrderingAscending = action.isOrderingAscending;
    return ctx.setState({
      ...state,
      ctf: state.ctf.sort((a: any, b: any) => {
        var columnToOrderSplitted = columnToOrder.split(".")[1];

        const valueA = Number(a[columnToOrderSplitted]);
        const valueB = Number(b[columnToOrderSplitted]);
        // if value is null, it should be always at the end not depending on the order
        if (valueA == 0) {
          return 1;
        }
        if (valueB == 0) {
          return -1;
        }
        return isOrderingAscending ? valueA - valueB : valueB - valueA;
      }),
    });
  }
}
